// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "3da9c2076a8f28b68673" + ".bundle.js";
};